<template>
  <div class="scroll-bar">
    <PerfectScrollbar
      data-testid="scrollbar"
      :options="options"
      :class="{
        'faded-scrolling': faded,
        disabled: disabled
      }"
      v-bind="$attrs"
    >
      <slot />
    </PerfectScrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'

export default {
  name: 'ScrollBar',
  components: { PerfectScrollbar },
  props: {
    suppressScrollX: {
      type: Boolean,
      default: false
    },
    suppressScrollY: {
      type: Boolean,
      default: false
    },
    faded: {
      type: Boolean,
      default: false
    },
    swipeEasing: {
      type: Boolean,
      default: false
    },
    largeScrollbarLength: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      const {
        suppressScrollX,
        suppressScrollY,
        swipeEasing,
        largeScrollbarLength,
        disabled
      } = this

      return {
        maxScrollbarLength: largeScrollbarLength ? 500 : 78,
        suppressScrollX: suppressScrollX || disabled,
        suppressScrollY: suppressScrollY || disabled,
        swipeEasing
      }
    }
  }
}
</script>

<style scoped lang="scss">
.scroll-bar {
  width: 100%;

  ::v-deep(.ps) {
    width: 100%;

    &.disabled {
      overflow: visible !important;
    }

    &.faded-scrolling {
      &.ps--active-y::after {
        content: '';
        position: sticky;
        width: 100%;
        height: var(--space-20);
        display: block;
        bottom: -1px;
        background: linear-gradient(
            180deg,
            rgb(255 255 255 / 0%) 0%,
            var(--color-white) 100%
        );
        z-index: 1;
      }
    }

    .ps__thumb-y {
      right: 0;
    }

    .ps__thumb-x {
      bottom: 0;
    }

    .ps__rail-y,
    .ps__rail-x {
      background-color: rgb(0 0 0 / 0%);
      opacity: 1;
      z-index: 2;
      max-height: 100%;
      max-width: 100%;
    }
  }
}
</style>
